// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InnerSubPageMenu_wrapper__WHirs"};